import { runAz } from "./az.js";

export interface AciState {
  provisioningState?: string;
  firstContainerState?: string;
  exitCode?: number;
  terminated: boolean;
}

export async function getAciState(opts: {
  aciName: string;
  resourceGroup: string;
  subscriptionId: string;
  azFn?: (args: string[]) => Promise<string>;
}): Promise<AciState> {
  const az = opts.azFn ?? runAz;
  const raw = await az([
    "container", "show", "-n", opts.aciName, "-g", opts.resourceGroup,
    "--subscription", opts.subscriptionId, "-o", "json",
  ]);
  const j = JSON.parse(raw) as {
    provisioningState?: string;
    containers?: { instanceView?: { currentState?: { state?: string; exitCode?: number } } }[];
  };
  const cs = j.containers?.[0]?.instanceView?.currentState;
  const state = cs?.state;
  const terminated = state === "Terminated" || state === "Failed" || j.provisioningState === "Failed";
  return { provisioningState: j.provisioningState, firstContainerState: state, exitCode: cs?.exitCode, terminated };
}
